import { Button, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useEmailVerification from '../../hooks/useEmailVerification';
import { useCallback, useContext, useState } from 'react';
import EmailVerificationModal from '../Page/EmailVerificationModal';
import { AuthContext } from './AuthProvider';

export default function EmailVerificationAlert() {
  const { t } = useTranslation();
  const { actions } = useContext(AuthContext);
  const [modalOpen, setModalOpen] = useState(false);
  const {
    sendVerificationEmail,
    isSendingVerificationEmail,
    state: emailVerificationState,
  } = useEmailVerification();

  const closeModal = async () => {
    setModalOpen(false);
    await actions?.getUserInfoWithoutCache();
  };

  const startEmailVerification = useCallback(async () => {
    await sendVerificationEmail();
    setModalOpen(true);
  }, [sendVerificationEmail]);

  return (
    <>
      <Alert
        severity='warning'
        variant='outlined'
        sx={{ marginBottom: 5 }}
        action={
          <Button
            size='small'
            variant='contained'
            onClick={startEmailVerification}
            loading={!modalOpen && isSendingVerificationEmail}
            loadingPosition='end'
          >
            {t('verifyEmail.confirmYourEmailAddress')}
          </Button>
        }
      >
        {t('verifyEmail.emailAddressNotVerified')}
      </Alert>
      <EmailVerificationModal
        open={modalOpen}
        handleClose={closeModal}
        sendVerificationEmail={sendVerificationEmail}
        state={emailVerificationState}
      />
    </>
  );
}
